module.exports = __webpack_public_path__ + "c3e93503b99d6595ea14ca5ff0e73788.svg";